module.exports = __webpack_public_path__ + "img/9788954617567.0e474b99.jpg";